document.addEventListener('DOMContentLoaded', function() {
  const interactiveSlider = document.getElementById('interactiveProductSlider');
  
  if (!interactiveSlider) return;

  // Function to set up tab functionality
  function setupTabs() {
    const activeTab = interactiveSlider.querySelector('.tab-button.active');
    
    if (activeTab) {
      // Ensure active tab is properly styled
      activeTab.classList.add('active');
    }
  }

  // Initialize Swiper (with manual class enforcement to avoid stuck active state)
  const productSwiper = new Swiper('.product-swiper', {
      slidesPerView: 1,
      spaceBetween: 30,
      effect: 'fade',              // keep fade; remove if still issues
      fadeEffect: { crossFade: true },
      speed: 500,
      allowTouchMove: true,
      autoHeight: false,           // disable autoHeight to reduce class glitches
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      pagination: { el: '.swiper-pagination', clickable: true },
      on: {
        afterInit(sw){ forceActiveClasses(sw); },
        slideChange(sw){ forceActiveClasses(sw); },
        transitionEnd(sw){ forceActiveClasses(sw); }
      }
    });

    // Manual fallback to ensure active/prev/next classes are correct
    function forceActiveClasses(sw){
      if(!sw || !sw.slides) return;
      const active = sw.activeIndex;
      sw.slides.forEach((slide, idx)=>{
        slide.classList.remove('swiper-slide-active','swiper-slide-prev','swiper-slide-next');
        if(idx === active){
          slide.classList.add('swiper-slide-active');
        } else if(idx === active-1){
          slide.classList.add('swiper-slide-prev');
        } else if(idx === active+1){
          slide.classList.add('swiper-slide-next');
        }
      });
    }

  // Tab click handler
  function handleTabClick() {
    const tabs = interactiveSlider.querySelectorAll('.tab-button');
    
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function() {
        // Update active tab
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        
        // Slide to corresponding slide
        productSwiper.slideTo(index);
      });
    });
    
    // Update tabs when slide changes
    productSwiper.on('slideChange', function() {
      const activeIndex = productSwiper.activeIndex;
      
      tabs.forEach((tab, index) => {
        if (index === activeIndex) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });
      
      const activeTab = tabs[activeIndex];
      if (activeTab && tabIndicator) {
        tabIndicator.style.width = `${activeTab.offsetWidth}px`;
        tabIndicator.style.transform = `translateX(${activeTab.offsetLeft}px)`;
      }
      
      // Update mobile dropdown
      updateMobileDropdown(activeIndex);
    });
  }

  // Mobile dropdown functionality
  function setupMobileDropdown() {
    const customSelect = interactiveSlider.querySelector('.custom-select');
    if (!customSelect) return;

    const select = customSelect.querySelector('select');
    const selectItems = customSelect.querySelector('.select-items');
    
    // If dropdown elements already exist, remove them first
    const existingSelected = customSelect.querySelector('.select-selected');
    const existingItems = customSelect.querySelector('.select-items');
    if (existingSelected) existingSelected.remove();
    if (existingItems) existingItems.remove();

    // Create the selected item display
    const selectedDiv = document.createElement('div');
    selectedDiv.className = 'select-selected';
    selectedDiv.textContent = select.options[select.selectedIndex].textContent;
    customSelect.appendChild(selectedDiv);

    // Create the dropdown items container
    const itemsDiv = document.createElement('div');
    itemsDiv.className = 'select-items select-hide';

    // Create dropdown items (skip first option if it's a placeholder)
    for (let i = 0; i < select.options.length; i++) {
      const option = select.options[i];
      const itemDiv = document.createElement('div');
      itemDiv.textContent = option.textContent;
      itemDiv.dataset.value = option.value;
      
      // Mark selected item
      if (i === select.selectedIndex) {
        itemDiv.className = 'same-as-selected';
      }

      // Add click handler
      itemDiv.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Update select element
        select.selectedIndex = i;
        
        // Update display
        selectedDiv.textContent = this.textContent;
        
        // Update active states
        const allItems = itemsDiv.querySelectorAll('div');
        allItems.forEach(item => item.classList.remove('same-as-selected'));
        this.classList.add('same-as-selected');
        
        // Trigger slide change
        productSwiper.slideTo(parseInt(this.dataset.value));
        
        // Close dropdown
        closeAllSelect(selectedDiv);
      });

      itemsDiv.appendChild(itemDiv);
    }

    customSelect.appendChild(itemsDiv);

    // Add click handler to selected div
    selectedDiv.addEventListener('click', function(e) {
      e.stopPropagation();
      closeAllSelect(this);
      itemsDiv.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
  }

  // Close all select boxes function
  function closeAllSelect(elmnt) {
    const selectItems = document.querySelectorAll('.select-items');
    const selectSelected = document.querySelectorAll('.select-selected');
    
    selectSelected.forEach((selected, index) => {
      if (elmnt !== selected) {
        selected.classList.remove('select-arrow-active');
      }
    });
    
    selectItems.forEach((items, index) => {
      if (elmnt !== selectSelected[index]) {
        items.classList.add('select-hide');
      }
    });
  }

  // Update mobile dropdown when slide changes
  function updateMobileDropdown(activeIndex) {
    const customSelect = interactiveSlider.querySelector('.custom-select');
    if (!customSelect) return;

    const select = customSelect.querySelector('select');
    const selectedDiv = customSelect.querySelector('.select-selected');
    const items = customSelect.querySelectorAll('.select-items div');

    if (select && selectedDiv) {
      select.selectedIndex = activeIndex;
      selectedDiv.textContent = select.options[activeIndex].textContent;
      
      // Update active states
      items.forEach((item, index) => {
        item.classList.remove('same-as-selected');
        if (index === activeIndex) {
          item.classList.add('same-as-selected');
        }
      });
    }
  }

  // Close dropdown when clicking outside
  document.addEventListener('click', closeAllSelect);

  // Initialize everything
  setupTabs();
  handleTabClick();
  setupMobileDropdown();
  // Ensure initial class correctness
  forceActiveClasses(productSwiper);
  
  // Handle window resize for responsive design if needed
  window.addEventListener('resize', function() {
    // Empty for now, add responsive handlers if needed
  });
});
